module.exports = __webpack_public_path__ + "static/media/download-share.7aad86b8.svg";